import React, { useState, useEffect } from 'react';
import PostArea from "../../../components/PostArea/PostArea.js";
import Skeleton from '@material-ui/lab/Skeleton';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import API from '../../../api/api';
import { getImageUrl } from '../../../utils/imageUtils';

const garageApi = new API();

export default function ServiceSection() {

  const [posts, setPosts] = useState([]);
  const [snackBar, setSnackBar] = useState(false);
  const [loadingPosts, setLoadingPosts] = useState(false);

  useEffect(() => {

    garageApi.openEndpoints.posts.getPage( { get: { limit: 3, offset: 0 } } )
      .then((postsGET) => {
        try
        {
          console.log('Posts API response:', postsGET);
          
          // Unterstütze sowohl results als auch direkte Arrays
          let posts = [];
          if (postsGET && postsGET.data) {
            if (Array.isArray(postsGET.data)) {
              posts = postsGET.data;
            } else if (postsGET.data.results && Array.isArray(postsGET.data.results)) {
              posts = postsGET.data.results;
            }
          }
          posts = [...posts].sort((a, b) => {
            const dateA = new Date(a.created || a.updated || 0).getTime();
            const dateB = new Date(b.created || b.updated || 0).getTime();
            if (dateB !== dateA) return dateB - dateA;
            return (Number(b.id) || 0) - (Number(a.id) || 0);
          }).slice(0, 3);
          
          console.log('Parsed posts:', posts);
          setPosts(posts);
          setLoadingPosts(true);
        }
        catch(e)
        {
          console.error('Error parsing posts:', e);
          setPosts([]);
          setSnackBar(true);
        }

      })
      .catch((error) => {
        console.error('Error loading posts:', error);
        setPosts([]);
        setLoadingPosts(true);
      });

  }, []);

  function closeSnackBar (event, reason)
  {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBar(false);
  }

  return (
    <section className="spg-section">
      <Snackbar open={snackBar} autoHideDuration={6000} onClose={closeSnackBar}>
        <MuiAlert elevation={6} variant="filled" onClose={closeSnackBar} severity="warning" >Server Fehler 500</MuiAlert>
      </Snackbar>
      <div className="spg-kicker">Aktuell</div>
      <h2 className="spg-title">Mitteilungen</h2>
      <div className="spg-grid" style={{ marginTop: 36 }}>
          { loadingPosts ?
            <>
              { Array.isArray(posts) && posts.length > 0 ? posts.map(function(post){
                return (
                  <PostArea
                    key={post.unikey}
                    title={post.title}
                    description={post.description}
                    image={post.image ? getImageUrl(post.image, 'medium') || '' : ''}
                    unikey={post.unikey}
                  />
                )
               }) : (
                <p className="spg-lead">Noch keine Mitteilungen – im Admin können Beiträge angelegt werden.</p>
               )}
             </>
            :
            Array.from({ length: 3 }, (_, i) =>
              <PostArea
                key={i}
                title={<Skeleton variant="text" width={'100%'} />}
                description={<Skeleton variant="rect" width={'100%'} height={118} />}
                image={<Skeleton variant="rect" width={'100%'} height={100} />}
                unikey=""
              />
            )
          }
      </div>
    </section>
  );
}
